export default function (props: any) {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.0625 11.3914C11.0382 13.4672 8.77205 16.5672 7.76416 20.1912M12.9006 36.6052C15.6399 38.8813 19.1601 40.2501 23 40.2501C26.7971 40.2501 30.2815 38.9117 33.0074 36.681M38.2587 20.2744C37.2497 16.5677 34.9263 13.4029 31.8201 11.3115"
                stroke="#FFBD3C"
                strokeWidth="2.875"
                strokeLinecap="round"
            />
            <circle cx="23" cy="9.58325" r="4.3125" stroke="#FFBD3C" strokeWidth="2.875" />
            <circle cx="9.58334" cy="28.75" r="4.3125" stroke="#FFBD3C" strokeWidth="2.875" />
            <circle cx="36.4167" cy="28.75" r="4.3125" stroke="#FFBD3C" strokeWidth="2.875" />
        </svg>
    );
}
